import { render } from "./AiReportBulkGenerateDialog.vue?vue&type=template&id=3c21a0c0&ts=true"
import script from "./AiReportBulkGenerateDialog.vue?vue&type=script&lang=ts"
export * from "./AiReportBulkGenerateDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__